module.exports = __webpack_public_path__ + "static/1216786444-exit.4afc284e.jpg";